var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as Utils from '@datocms/rest-client-utils';
import BaseResource from '../../BaseResource';
var JobResult = /** @class */ (function (_super) {
    __extends(JobResult, _super);
    function JobResult() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Retrieve a job result
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/job-result/self
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    JobResult.prototype.find = function (jobResultId) {
        return this.rawFind(Utils.toId(jobResultId)).then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * Retrieve a job result
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/job-result/self
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    JobResult.prototype.rawFind = function (jobResultId) {
        return this.client.request({
            method: 'GET',
            url: "/job-results/".concat(jobResultId),
        });
    };
    JobResult.TYPE = 'job_result';
    return JobResult;
}(BaseResource));
export default JobResult;
//# sourceMappingURL=JobResult.js.map